<template>
    <b-modal no-close-on-esc  content-class="m-0"  id="modal-delete" scrollable no-close-on-backdrop @hide="deleteModalClose">
        <p class="font-weight-bold">{{dicts.head[dicts.lang]}}</p>
            <b-container fluid>
                <b-row class="pt-1">
                <b-col cols="12">
                    <slot>{{subheading}}</slot>
                </b-col>
                <b-col cols="12" class="my-3 text-right"  v-if="deleteState">
                    <div class="d-flex align-items-center justify-content-start">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <strong class=" ml-2">{{processtext}}</strong>
                        </div>
                    </b-col>
                    <div class="col-12 mt-3"  v-if="deleted">
                        <div class="w-100 align-items-center justify-content-start">
                            <div class="alert alert-success" role="alert">
                                {{ successtext }}
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3"  v-if="deleteFail">
                        <div class="w-100 align-items-center justify-content-start">
                            <div class="alert alert-danger" role="alert">
                                {{ failtext }}
                            </div>
                        </div>
                    </div>
                </b-row>
            </b-container>
            <template #modal-footer>
                <div class="w-100 text-right m-0 p-0">
                <hr>
                <button class="btn btn-danger mr-2" v-on:click="deleteData">{{dicts.button[dicts.lang]}}</button>
                <b-button class="btn btn-secondary" @click="(!deleteState)?$bvModal.hide('modal-delete'):''">{{dicts.close[dicts.lang]}}</b-button>
                </div>
            </template>
        </b-modal>
</template>
<script>
import {EventBus} from './../eventbus'
import * as axios from 'axios';
export default {
    props:{
        head:{type:String,default:'Verifikasi Hapus Data'},
        subheading:{type:String,default:'Apakah Anda Yakin Menghapus Data ini?'},
        // oktext:{type:String,default:'ya, hapus'},
        // canceltext:{type:String,default:'Tutup'},
        processtext:{type:String,default:'Menghapus data, tunggu sebentar'},
        failtext:{type:String,default:'Gagal menghapus data'},
        successtext:{type:String,default:'Berhasil menghapus data'},
        url:String,
        targetid:Number,
    },
    data(){
        return{
            deleted:false,
            deleteState:false,
            deleteFail:false,
            dicts:{
                lang:'id',
                head:{
                    id:"Verifikasi Hapus Data",
                    en:"Verify Erase Data"
                },
                button:{
                    id:"Ya, hapus",
                    en:"Yes, delete it"
                },
                close:{
                    id:"Tutup",
                    en:"Close"
                }
            }
        }
    },
    created(){
        this.$emit("ready")
        EventBus.$on('lang',()=>{
        this.dicts.lang = localStorage.getItem('lang');
      })
    },
    
    methods:{
        deleteModalClose(){
            console.log("test")
        },
        sendResult(result){
            this.$emit('result',result)
        },
        deleteData(){
            this.sendResult(false)
            console.log('deleting')
            this.deleteState=true
            axios.delete(this.$baseUrl+this.url+this.targetid,{
                headers:{'Authorization':'Bearer '+ localStorage.getItem('accessToken')}
            })
            .then((result)=>{
                console.log("done")
                console.log(this)
                if(result.status==200){
                    this.deleted=true;

                    console.log(this)
                    setTimeout(() => {
                        this.deleted=false;
                        this.sendResult(true)
                        this.$bvModal.hide('modal-delete')
                    }, 1000);
                }else{
                    this.deleteFail=true
                    this.$nextTick(() => {
                        this.sendResult(false)
                    });
                }
                this.deleteState=false
            }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
                this.$nextTick(() => {
                    this.sendResult(false)
                });
                console.log(err.response)
                this.deleteState=false
                this.deleteFail=true
            })
        }
    }
}
</script>